/*global translate*/
import React, { Component } from 'react'
// import { FixedSizeList as List } from 'react-window'
import { connect } from 'react-redux'

import { List } from 'react-virtualized'
global.isclient && require('./rxTagName.css')
const { rxaget, subString,stringToColour ,rxChangeSlug,changeColorSVG} = global.rootRequire('classes/ulti')
const { checkNameUser, checkNameContact, changeColorAva, textAva } = global.rootRequire('classes/chat')
const chatDB = global.rootRequire('classes/indexedDB').default

class rxTagName_ extends Component {
  constructor (props) {
    super(props)
    this.state = {
      group_id: '',
      indexRowActive: 0,
      tagNameQuery: props.tagNameQuery
    }
    this.lengthUsers = 0
    this.occupantsUins = []
    this.occupantsUinsOrigin = []
    this.allMention = {
      Id: 1,
      full_name: "@All",
      id: 1,
      is_hide_searched: 0,
      login: "",
      my_cloud_id: 0,
      phone: "@All",
      uid: 1
    }
    // if (props.group && props.group.occupants_uins && props.group.occupants_uins.constructor === Array && props.group.occupants_uins.length > 0) {
    //   props.group.occupants_uins.forEach(uid => {
    //     if (props.users && props.users[uid] && uid != props.userid) {
    //       this.occupantsUins.push(props.users[uid])  
    //     }
    //   })
    // }
    this.getGroup(props.group_id)

    // this.occupantsUinsOrigin = this.occupantsUins
    // this.lengthUsers = this.occupantsUins.length

    this.outerListRef = React.createRef() 
    this.innerListRef = React.createRef()

    this.scrollOffset = 0
    this.listHeight = 150

    this.keyClickFunction = this.keyClickFunction.bind(this)
  }


  componentDidMount() {
    document.addEventListener("keydown", this.keyClickFunction, false) 
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this.keyClickFunction, false)
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    try {
      if (nextProps && nextProps.tagNameQuery !== this.state.tagNameQuery) {
          if (nextProps.tagNameQuery !== '') {
            const escapedReplaceValue = rxaget(nextProps, 'tagNameQuery', '').replace(/[-\/\\^$*+?.()|[\]{}]/g, ''); 
            const dynamicPattern = new RegExp(`(?:\\s|^)${escapedReplaceValue}`, 'i');
            this.occupantsUins = this.occupantsUinsOrigin.filter(user => dynamicPattern.test(rxaget(user, 'full_name', '')));
            // this.occupantsUins = this.occupantsUinsOrigin.filter(user => rxaget(user, 'full_name', '').toLowerCase().indexOf(rxaget(nextProps, 'tagNameQuery', '').toLowerCase()) != -1 )
            this.lengthUsers = this.occupantsUins.length  
          } else {
            this.occupantsUins = this.occupantsUinsOrigin
            this.lengthUsers = this.occupantsUins.length
          }
          
        this.setState({
          tagNameQuery: nextProps.tagNameQuery
        })
      }
    } catch(e) {}
  }

  keyClickFunction(event) {
    try {
      const listHeight = 150
      const pageOffset = listHeight / 3
      const maxHeight =
        (this.innerListRef.current &&
          this.innerListRef.current.style.height.replace('px', '')) ||
        listHeight

      const minHeight = 0.1

      if(event.keyCode === 13) {
        if (this.lengthUsers !== 0) {
          event.preventDefault()
          this.tagName_SelectUser(this.state.indexRowActive)
        } else {
          this.tagName_SelectUser(-1)
        }
      }
  
      if(event.keyCode === 38) {
        this.scrollOffset = Math.max(minHeight, this.scrollOffset - pageOffset)
        if (this.state.indexRowActive > 0) {
          this.setState({indexRowActive: this.state.indexRowActive - 1})
        }
        event.preventDefault()      
      }  

      if(event.keyCode === 40) {
        this.scrollOffset = Math.min(this.scrollOffset + pageOffset, maxHeight)
        if (this.state.indexRowActive < this.lengthUsers - 1) {
          this.setState({indexRowActive: this.state.indexRowActive + 1})
        }
        event.preventDefault()
      }

      if (this.outerListRef.current) {
        if(event.keyCode === 40) {
          if (this.state.indexRowActive >= 3) {
            this.outerListRef.current.scrollToRow(this.state.indexRowActive)
          }
        }
        if(event.keyCode === 38) {
          this.outerListRef.current.scrollToRow(this.state.indexRowActive)
        }
      }
    } catch(e) {}
  }

  async getGroup(groupid) {
    let groupInDB = await chatDB.groups.get({group_id: groupid})
    if (groupInDB && groupInDB.occupants_uins) {
      let occupantsUins = groupInDB.occupants_uins.map(o => Number(o)).sort()

      let arrUins = await chatDB.users.bulkGet(occupantsUins);
      arrUins = arrUins.filter( Boolean )

      if (groupInDB && groupInDB.type !== 3 && !this.props.flagCheckAll) {
        arrUins.unshift(this.allMention)
      }
      
      console.log('dddddddddddd')
      this.occupantsUins = arrUins
      this.occupantsUinsOrigin = arrUins
      this.lengthUsers = arrUins.length
      this.setState({group_id: groupid})
    }
  }

  tagName_SelectUser(index) {
    if (index === -1) {
      this.props.onClick(null)  
    } else {
      let ele = this.occupantsUins[index]
      if (ele) {
        ele.name_contact = subString(checkNameUser(ele), 20)
        this.props.onClick(ele)      
      }
    }        
  }

  renderRow({ index, key, style }) {
    let ele = this.occupantsUins[index]
    return <div key={key} style={style}>
      {ele && <div className={ ((this.state.indexRowActive == index)) ? 'box-tagName_item_select' : 'box-tagName_item'} key={index} onClick={ (e) => this.tagName_SelectUser(index)} >     
        <div className='tagName_List_avatar'>
          {(ele.profile_url) && <img src={global.rxu.config.cdn_endpoint + ele.profile_url} alt='' className='tagName_List_ava-group images-static'
            onError={(e) => {e.target.onerror = null; e.target.src = './images/default/static/avadefault.svg' }} />}
          {(!ele.profile_url) && 
            <span className='tagName_List_ava-span' style={{ background: `${changeColorAva(rxaget(ele, 'id', ''))}` }}>{textAva(rxChangeSlug(checkNameUser(ele)))}</span>
          }
        </div>
        <div className='tagName_List_name'>{ ele.id === 1 ? '@'+translate('All') : subString(checkNameUser(ele), 20) } </div>
      </div>}
    </div>
  }

  render () {
    return (
      <div>
        {(this.lengthUsers > 0) && <div className='box-tagName-wrap'>       
          <div className='box-tagName'>
            <div className = 'tagName_List_place'>
              <div className='tagName_List' id = 'tagName_List_id'>
                {/* {this.occupantsUins.length > 0 && <List
                  outerRef={this.outerListRef}
                  innerRef={this.innerListRef}
                  height={150}
                  itemCount={this.lengthUsers}
                  itemSize={50}
                  itemData={this.occupantsUins}
                  width={300}
                > 
                  {
                    ({ data, index, isScrolling, style }) => {
                      let ele = data[index]
                      return <div style={style}>
                        {ele && <div className={ ((this.state.indexRowActive == index)) ? 'box-tagName_item_select' : 'box-tagName_item'} key={index} onClick={ (e) => this.tagName_SelectUser(index)} >     
                          <div className='tagName_List_avatar'>
                            {(ele.profile_url) && <img src={global.rxu.config.cdn_endpoint + ele.profile_url} alt='' className='tagName_List_ava-group images-static'
                              onError={(e) => {e.target.onerror = null; e.target.src = './images/default/static/avadefault.svg' }} />}
                            {(!ele.profile_url) && 
                              <span className='tagName_List_ava-span' style={{ background: `${changeColorAva(rxaget(ele, 'id', ''))}` }}>{textAva(rxChangeSlug(checkNameUser(ele)))}</span>
                            }
                          </div>
                          <div className='tagName_List_name'>{ ele.id === 1 ? '@'+translate('All') : subString(checkNameUser(ele), 20) } </div>
                        </div>}
                      </div>
                    }
                  }
                </List>} */}

                <List
                  width={300}
                  height={150}
                  rowHeight={50}
                  rowRenderer={this.renderRow.bind(this)}
                  rowCount={this.occupantsUins.length}
                  overscanRowCount={3} 
                  ref={this.outerListRef}
                />

               </div> 
             </div> 
            <div className='tagName-box-tail'><i className='icon-tagName-tail'></i></div>
          </div>
        </div>}
      </div>
    )
  }
}


export default rxTagName_